import React from 'react'
import PropTypes from 'prop-types'
import BookingPaymentForm from 'forms/client/payment-booking'
import { withRouter } from 'react-router-dom';

const BookingPayment = ({ match }) => (
  <div className="bookings-checkout">
    <div className="container mx-auto my-10">
      <BookingPaymentForm {...match.params} />
    </div>
  </div>
)

BookingPayment.propTypes = {
  match: PropTypes.object.isRequired,
}

export default withRouter(BookingPayment)
